import {
  PromptConfigViewContainer,
  LeftColumn,
  RightColumn
} from "./PromptConfigView.styled.jsx";
import PromptConfiguration from "../PromptConfiguration/PromptConfiguration";

const PromptConfigView = () => {
  return (
    <PromptConfigViewContainer>
      <LeftColumn>
        <PromptConfiguration />
      </LeftColumn>
    </PromptConfigViewContainer>
  );
};

export default PromptConfigView;
